import sule from '../images/sule.png';
import dilan from '../images/dilan.png';

const TeamSection = () => {
    return (
        <section className="flex flex-col items-center justify-center px-6 md:px-16 py-24 gap-12 bg-black">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
                <img
                    src={sule}
                    alt="Sule"
                    className="rounded-3xl shadow-xl w-44 sm:w-52 lg:w-60 hover:scale-105 transition"
                />
                <img
                    src={dilan}
                    alt="Dilan"
                    className="rounded-3xl shadow-xl w-44 sm:w-52 lg:w-60 hover:scale-105 transition"
                />
            </div>
        </section>
    )
}
export default TeamSection;